import axios from 'axios';

// Cache leggera lato client per le chiamate GET più frequenti e a bassa variabilità.
// - I GET verso gli endpoint in CACHEABLE vengono serviti dalla cache per CACHE_TTL ms.
// - Qualsiasi mutazione riuscita (POST/PUT/PATCH/DELETE) svuota la cache, così dopo un
//   salvataggio la lettura successiva è sempre aggiornata.
const CACHE_TTL = 60_000; // 60 secondi
const CACHEABLE = ['/products/catalog', '/admin/vans'];
const cache = new Map(); // key -> { ts, response }

function keyFor(config) {
    const params = config.params ? JSON.stringify(config.params) : '';
    return `${config.baseURL || ''}${config.url || ''}?${params}`;
}

function isCacheableGet(config) {
    const method = (config.method || 'get').toLowerCase();
    if (method !== 'get') return false;
    const url = config.url || '';
    return CACHEABLE.some((p) => url.includes(p));
}

let installed = false;

export function installHttpCache() {
    if (installed) return;
    installed = true;

    const baseAdapter = axios.getAdapter(axios.defaults.adapter);

    axios.defaults.adapter = async function cachingAdapter(config) {
        const method = (config.method || 'get').toLowerCase();

        if (isCacheableGet(config)) {
            const k = keyFor(config);
            const hit = cache.get(k);
            if (hit && Date.now() - hit.ts < CACHE_TTL) {
                return { ...hit.response, config, cached: true };
            }
            const response = await baseAdapter(config);
            cache.set(k, { ts: Date.now(), response });
            return response;
        }

        const response = await baseAdapter(config);
        if (method !== 'get') cache.clear();
        return response;
    };
}

export function clearHttpCache() {
    cache.clear();
}
